export default [
    // SEND NEWS
    {
        path: '/news/send',
        name: 'news-send',
        component: () => import('@/views/pages/news/SendNews.vue'),
    },
    {
        path: '/news/send/:id',
        name: 'news-send-update',
        component: () => import('@/views/pages/news/SendNews.vue'),
    },
    {
        path: '/news/manage',
        name: 'news-manage',
        component: () => import('@/views/pages/news/manage/ManageNews.vue'),
        meta: {
            contentRenderer: 'sidebar-left',
            contentClass: 'email-application',
        }
    },
    {
        path: '/news/statistics',
        name: 'news-statistics',
        component: () => import('@/views/pages/dashboard/Statistics.vue'),
        meta: {
            contentRenderer: 'sidebar-left',
            contentClass: 'email-application',
        },
        children: [
            {
                path: 'news',
                name: 'report-news',
                props: route => ({ urlQuery: route.query }),
                component: () => import('@/views/pages/report/ReportByUser.vue'),
            },
            {
                path: 'register',
                name: 'report-leads',
                component: () => import('@/views/pages/report/ReportLeads.vue'),
                navActiveLink: 'admin-user',
            },
            {
                path: 'register',
                name: 'report-demos',
                component: () => import('@/views/pages/report/ReportDemoRequest.vue'),
                navActiveLink: 'admin-user',
            },
        ]
    },
    // {
    //     path: '/news/manage/:layout',
    //     name: 'news-manage-layout',
    //     component: () => import('@/views/pages/news/manage/ManageNews.vue'),
    //     meta: {
    //         contentRenderer: 'sidebar-left',
    //         contentClass: 'email-application',
    //         navActiveLink: 'news-manage',
    //     }
    // },

]
